<template>
	<v-dialog v-model="open" width="700">
		<template v-slot:activator="{ on, attrs }">
			<slot name="activator" v-bind="{ on, attrs }">
				<v-btn right icon small v-bind="attrs" v-on="on">
					<v-icon dense :color="activatorColor">{{ activatorIcon }}</v-icon>
				</v-btn>
			</slot>
		</template>
		<template v-slot:default="">
			<v-card>
				<dev-form-edit
					v-if="open"
					max-content-height="calc(90vh - 120px)"
					:insert="insert"
					:imot="imot"
					:device="device"
					:session="session"
					:init="initData"
					:title="title"
					@close="open = false"
					@saveclose="open = false; $emit('reload')"
				/>
			</v-card>
		</template>
	</v-dialog>
</template>

<script>
import {phpDate} from "@/ittijs/utils";
import SelectedUtilityMixin from "@/ittijs/SelectedUtilityMixin";
import DevFormEdit from "@/ittijs/components/DeviceDataList/DevFormEdit.vue";

export default {
	mixins: [SelectedUtilityMixin],
	components: {
		DevFormEdit,
	},
	props: {
		'title': String,
		'device': {},
		'session': {},
		'imot': {}, // if inserting, instead of device
		'insert': Boolean,
		'copy': {}, // when inserting, use this device as template
	},
	data(){
		return {
			open: false,
		}
	},
	computed: {
		initData(){
			if (this.copy) {
				const res = {...this.copy};
				delete res.id;
				res['mount_date'] = phpDate('Y-m-d');
				return res;
			}
			else {
				return {
					mount_date: phpDate('Y-m-d'),
				}
			}
		},
		activatorColor(){
			return this.insert ? 'green' : 'primary';
		},
		activatorIcon(){
			if (!this.insert) {
				return 'mdi-pencil-circle';
			}
			if (this.copy) {
				return 'mdi-alpha-c-circle';
			}
			return 'mdi-plus-circle';
		},
	},
}
</script>